<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5606 4.31067C14.9749 3.72489 14.0251 3.72489 13.4394 4.31068L10.4394 7.31069C10.158 7.59199 10 7.97352 10 8.37135V10.0001H11.6287C12.0265 10.0001 12.408 9.84204 12.6894 9.56071L15.6894 6.56066C16.2751 5.97486 16.2751 5.02512 15.6894 4.43934L15.5606 4.31067Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 10H5.5C4.67157 10 4 10.6716 4 11.5C4 12.3284 4.67157 13 5.5 13H13C13.8284 13 14.5 13.6716 14.5 14.5C14.5 15.3284 13.8284 16 13 16H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BriefsTabIcon'
}
</script>

